import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { useContent } from "@/lib/hooks";
import PageHeader from "@/components/PageHeader";

export default function Campaigns() {
  const { t, ml } = useLang();
  const { data: campaigns = [], isLoading } = useContent("/content/campaigns");

  return (
    <div data-testid="campaigns-page">
      <PageHeader title={t("campaigns.title")} subtitle={t("campaigns.subtitle")} testId="campaigns-title" />
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        {isLoading ? (
          <p className="text-zinc-500">{t("common.loading")}</p>
        ) : campaigns.length === 0 ? (
          <p className="text-zinc-500" data-testid="campaigns-empty">{t("campaigns.empty")}</p>
        ) : (
          <div className="space-y-10" data-testid="campaigns-list">
            {campaigns.map((campaign, idx) => (
              <div
                key={campaign.id}
                className={`grid grid-cols-1 overflow-hidden rounded-2xl border border-zinc-200 bg-white lg:grid-cols-12 ${
                  idx % 2 === 1 ? "lg:[direction:rtl]" : ""
                }`}
              >
                <div className="lg:col-span-5 lg:[direction:ltr]">
                  <img src={campaign.image} alt={ml(campaign.title)} className="h-64 w-full object-cover lg:h-full" />
                </div>
                <div className="p-9 lg:col-span-7 lg:p-12 lg:[direction:ltr]">
                  <span className="inline-block rounded-full bg-[#EEF2FF] px-3.5 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-[#1A4BFF]">
                    {ml(campaign.badge)}
                  </span>
                  <h2 className="mt-5 font-heading text-2xl font-black tracking-tight text-zinc-950 md:text-3xl">
                    {ml(campaign.title)}
                  </h2>
                  <p className="mt-4 max-w-xl text-base leading-relaxed text-zinc-600">{ml(campaign.description)}</p>
                  <Link
                    to="/iletisim"
                    data-testid={`campaign-apply-${idx}`}
                    className="mt-7 inline-flex items-center gap-2 rounded-lg bg-[#1A4BFF] px-6 py-3 text-sm font-bold text-white transition-colors duration-200 hover:bg-[#0033CC]"
                  >
                    {t("campaigns.apply")}
                    <ArrowRight className="h-4 w-4 rtl:rotate-180" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
